import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import { TEMPLATE_SKELETON_LINE, TEMPLATE_SKELETON_ROUNDED } from './templateSkeletonCommon'

const CARD_BORDER = '#e2e8f0'

export function TemplateTileSkeleton() {
  return (
    <Box
      data-testid="instrument-template-tile-skeleton"
      sx={{
        border: `1px solid ${CARD_BORDER}`,
        borderRadius: '12px',
        bgcolor: '#ffffff',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: '24px',
        minHeight: '162px',
        p: '25px',
        width: '100%',
      }}
    >
      <Skeleton
        variant="rounded"
        width={64}
        height={64}
        sx={TEMPLATE_SKELETON_ROUNDED}
        aria-hidden
      />
      <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
        <Skeleton variant="rounded" width="55%" height={28} sx={TEMPLATE_SKELETON_LINE} />
        <Skeleton variant="rounded" width="92%" height={20} sx={TEMPLATE_SKELETON_LINE} />
        <Skeleton variant="rounded" width="78%" height={20} sx={TEMPLATE_SKELETON_LINE} />
        <Stack direction="row" spacing={2} sx={{ pt: 1 }}>
          <Skeleton variant="rounded" width={108} height={20} sx={TEMPLATE_SKELETON_LINE} />
          <Skeleton variant="rounded" width={88} height={20} sx={TEMPLATE_SKELETON_LINE} />
        </Stack>
      </Stack>
    </Box>
  )
}
